module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (2).e05b378d.svg";